import React from 'react';

const Testimonials = () => {
  return (
    <div className="container mt-5">
      <h1>What Our Students Say</h1>
      <div className="row">
        <div className="col-md-6">
          <div className="card mb-4">
            <div className="card-body">
              <p className="card-text">"The coaching at Polonsky Academy has been exceptional. My rating has increased by 200 points in just a few months!"</p>
              <footer className="blockquote-footer">John Doe</footer>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card mb-4">
            <div className="card-body">
              <p className="card-text">"I highly recommend Polonsky Academy to anyone serious about improving their chess. The instructors are top-notch."</p>
              <footer className="blockquote-footer">Jane Smith</footer>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
